var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pivotData)?_c('vue-pivottable-ui',{attrs:{"data":_vm.pivotData,"aggregator-name":_vm.aggregatorName,"renderer-name":"Table Heatmap","row-total":true,"col-total":true,"rows":_vm.rows,"cols":_vm.cols,"vals":_vm.vals,"localeStrings":_vm.localeStrings['es']}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }